import { FC } from 'react';

import { LegalClientVersionEntity } from 'api/types/entity';
import { NavigationBreadcrumbsTitles } from 'components';
import { LayoutWithNavigationBreadcrumbs } from 'components/LayoutWithNavigationBreadcrumbs';
import { Form } from 'libs/form/Form';
import { getVersionDate } from 'modules/client/common/helpers';
import { VersionView } from 'modules/client/common/views';

import {
  LegalClientHeadSections,
  LegalClientHeadSectionsProps,
} from '../components';
import { LegalClientHeadFormType } from '../forms/legalClientHeadForm';

export interface LegalClientHeadVersionViewProps
  extends LegalClientHeadSectionsProps {
  breadcrumbsTitles: NavigationBreadcrumbsTitles;
  versions: LegalClientVersionEntity[];
  initialValues?: LegalClientHeadFormType;
  fullName: string;
  versionId: string;
  snapshotLoading?: boolean;
  error?: string;
  onChangeVersion: (version: LegalClientVersionEntity) => void;
  onCloseVersionHistory: () => void;
}

export const LegalClientHeadVersionView: FC<
  LegalClientHeadVersionViewProps
> = ({
  breadcrumbsTitles,
  versions,
  fullName,
  initialValues,
  snapshotLoading,
  versionId,
  error,
  onCloseVersionHistory,
  onChangeVersion,
  ...sectionsProps
}) => (
  <LayoutWithNavigationBreadcrumbs titles={breadcrumbsTitles}>
    <VersionView
      content={
        initialValues && (
          <Form
            initialReadOnly
            initialShowCopyButton
            initialValues={initialValues}
            onSubmit={() => {}}
          >
            <LegalClientHeadSections
              hideActivitySection
              countryRiskAt={getVersionDate(versions, versionId)}
              {...sectionsProps}
            />
          </Form>
        )
      }
      error={error}
      loading={snapshotLoading}
      name={fullName}
      versionId={versionId}
      versions={versions}
      onChangeVersion={onChangeVersion}
      onCloseVersionHistory={onCloseVersionHistory}
    />
  </LayoutWithNavigationBreadcrumbs>
);
